import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Update to default role when applying with country change
import { changeCurrentRole } from '../../../auth/actions';
import {
  getCurrentRole,
  getFormatedRoles
} from '../../../components/common/Profile/selector';
import {
  setGlobalCountryCostCenter,
  setGlobalDynamicFilter
} from '../../../action/CommonActions';
import { notify } from '../../../components/libs/notification';

import * as actions from '../actions';
import SchedulingReports from './SchedulingReports';
import { getReportsCCAndCountry } from '../selector';

const mapStateToProps = state => ({
  role: getCurrentRole(state),
  roles: getFormatedRoles(state),
  ...getReportsCCAndCountry(state)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  changeCurrentRole: bindActionCreators(changeCurrentRole, dispatch),
  notify: bindActionCreators(notify, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(setGlobalDynamicFilter, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SchedulingReports);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/SchedulingReports/SchedulingReportsContainer.js